const PaymentModels = {
    FREE: 'FREE',
    PAID: 'PAID'
};

export default PaymentModels;
